import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import useStateRef from 'react-usestateref';
import { updateProfileDetailsAction } from '../../middleware/updateProfileDetailsAction';
import { miniCartItemCountAction } from '../../middleware/miniCartItemCountAction';
import CbMobileLogOut from './CbMobileLogOut';
import { useHistory } from 'react-router-dom';
import { useState } from 'react';

const MyAccountCommonize = () => {
    const history = useHistory();
    const profileDetails = useSelector(state => state.getProfileDetails.profileDetails)
    const [fullPath, setFullPath] = useState();
    useEffect(() => {
        setFullPath(history.location.pathname + (window.location ? window.location.search : ""))
    }, [])
    
    return (
        <>
            <div className={`col-lg-3 c-shopping-list-item-col d-lg-block ${fullPath === '/account/landing' || fullPath === '/checkout/landing' || fullPath === '/account/landing?create=true' ? 'd-block' : 'd-none'}`}>
                <div id="sidebar" className="mt-md-4">
                    <div className="row my-3 my-md-0">
                        <div className="col-6 col-md-6">
                            <h1 className="c-sidepanel-heading mt-0">My Account</h1>
                        </div>
                        <div className="col-6 col-md-6 d-lg-none">
                            <CbMobileLogOut />
                        </div>
                    </div>
                    <div className="c-side-list my-account-cus-mobile">
                        <ul className="list-group c-account-mobile-list c-list-group-custom">
                            <li className="list-group-item">
                                <Link to="/account/profile" className="list-group-item-action justify-content-start">
                                    <i className="bi bi-person"></i>
                                    My Profile<span className="c-list-icon">
                                        <i className="bi bi-caret-right-fill" aria-hidden="true"></i>
                                    </span>
                                </Link>
                            </li>
                            {profileDetails && profileDetails.userType && profileDetails.userType == '2' &&
                                <li className="list-group-item">
                                    <Link to="/account/b2i/organization-user" className="list-group-item-action justify-content-start">
                                        <i className="bi bi-journals"></i>
                                        My Organization<span className="c-list-icon">
                                            <i className="bi bi-caret-right-fill" aria-hidden="true"></i>
                                        </span>
                                    </Link>
                                </li>
                            }
                            <li className="list-group-item">
                                <Link to="/account/list" className="list-group-item-action justify-content-start">
                                    <i className="bi bi-card-list"></i>
                                    Shopping Lists
                                    <span className="c-list-icon">
                                        <i className="bi bi-caret-right-fill" aria-hidden="true"></i>
                                    </span>
                                </Link>
                            </li>
                            {profileDetails && profileDetails.userType && profileDetails.userType != '3' &&
                                <li className="list-group-item">
                                    <Link to="/account/order" className="list-group-item-action justify-content-start">
                                        <i className="bi bi-box-seam"></i>
                                        Order History
                                        <span className="c-list-icon">
                                            <i className="bi bi-caret-right-fill" aria-hidden="true"></i>
                                        </span>
                                    </Link>
                                </li>
                            }
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MyAccountCommonize;